import { useSelector } from 'react-redux'
import { determinateStatusTimezone } from '../../utils'
import { toZonedTime } from 'date-fns-tz'
import { format } from 'date-fns'

const useDate = () => {
  const today = useSelector(state => state.date.date);
  const timezone = useSelector(state => state.tenant?.timezone || 'Australia/Victoria')

  // funcion para validar el estado de una fecha
  const determinateStatus = (startDate, endDate) => {
    if (!startDate && !endDate) {
      return 'No date assigned'
    }
    
    return determinateStatusTimezone(toZonedTime(today, timezone), startDate, endDate, timezone)
  }

  const formatDate = (date, pattern = 'dd/MMM/yyyy') => {
    return format(toZonedTime(date, timezone), pattern)
  }

  return {
    formatDate,
    determinateStatus
  }
}

export default useDate